/*  ========================================================================
    # Scripts - Menus Mobile
    ========================================================================  */

/**
 * Script that handles the opening and closing of the "Mobile" and "Member Area" menu.
 */
const MenusMobile = {
  cfg: {
    body: document.querySelector('body'),
    mobile: {
      button: document.querySelector('.c-header__button-menu-mobile'),
      buttonActiveClass: 'c-header__button-menu-mobile--active',
      menu: document.querySelector('.c-menu-mobile'),
      menuVisibleClass: 'c-menu-mobile--visible'
    },
    memberArea: {
      button: document.querySelector('.c-header__button-menu-member-area'),
      buttonActiveClass: 'c-header__button-menu-member-area--active',
      menu: document.querySelector('.c-menu-member-area'),
      menuVisibleClass: 'c-menu-member-area--visible'
    }
  },

  /**
   * Handler.
   *
   * @param {object} button
   * @param {string} classButtonActive
   * @param {object} menu
   * @param {string} classMenuVisible
   * @param {object} otherButton
   * @param {string} classOtherButtonActive
   * @param {object} otherMenu
   * @param {string} classOtherMenuVisible
   */
  handler(
    button,
    classButtonActive,
    menu,
    classMenuVisible,
    otherButton,
    classOtherButtonActive,
    otherMenu,
    classOtherMenuVisible
  ) {
    button.addEventListener('click', () => {
      if (
        otherMenu !== undefined &&
        otherMenu !== null &&
        otherMenu.classList.contains(classOtherMenuVisible)
      ) {
        otherButton.classList.remove(classOtherButtonActive);
        otherMenu.classList.remove(classOtherMenuVisible);
      } else {
        this.cfg.body.style.overflow = this.cfg.body.style.overflow === 'hidden' ? '' : 'hidden';
      }

      button.classList.toggle(classButtonActive);
      menu.classList.toggle(classMenuVisible);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (
      this.cfg.mobile.button !== undefined &&
      this.cfg.mobile.button !== null &&
      this.cfg.mobile.menu !== undefined &&
      this.cfg.mobile.menu !== null
    ) {
      this.handler(
        this.cfg.mobile.button,
        this.cfg.mobile.buttonActiveClass,
        this.cfg.mobile.menu,
        this.cfg.mobile.menuVisibleClass,
        this.cfg.memberArea.button,
        this.cfg.memberArea.buttonActiveClass,
        this.cfg.memberArea.menu,
        this.cfg.memberArea.menuVisibleClass
      );
    }
    if (
      this.cfg.memberArea.button !== undefined &&
      this.cfg.memberArea.button !== null &&
      this.cfg.memberArea.menu !== undefined &&
      this.cfg.memberArea.menu !== null
    ) {
      this.handler(
        this.cfg.memberArea.button,
        this.cfg.memberArea.buttonActiveClass,
        this.cfg.memberArea.menu,
        this.cfg.memberArea.menuVisibleClass,
        this.cfg.mobile.button,
        this.cfg.mobile.buttonActiveClass,
        this.cfg.mobile.menu,
        this.cfg.mobile.menuVisibleClass
      );
    }
  }
};

export default MenusMobile;
